import * as React from 'react';
export const hypovorarlbergSvg = React.forwardRef(
  function hypovorarlbergSvgInner(props, ref) {
    return /*#__PURE__*/ React.createElement(
      'svg',
      {
        ...props,
        ref: ref,
      },
      /*#__PURE__*/ React.createElement(
        'g',
        {
          fill: 'none',
          fillRule: 'evenodd',
        },
        /*#__PURE__*/ React.createElement('path', {
          fill: '#0079C2',
          d: 'M0 0h32v32H0z',
        }),
        /*#__PURE__*/ React.createElement('path', {
          fill: '#FFF',
          fillRule: 'nonzero',
          d: 'M26.95 20.52c0 .57.3.9.8.9l.37-.02v-.98h.58v1.27c-.3.13-.64.19-1.02.19-.74 0-1.32-.4-1.32-1.31 0-.93.58-1.4 1.45-1.4.32 0 .57.06.76.15v.48c-.2-.1-.44-.18-.69-.18-.58 0-.93.3-.93.9zm-1.44 1.31-.58-.99h-.38v.98h-.58v-2.6h.96c.7 0 1.02.26 1.02.77 0 .29-.19.53-.5.66l.73 1.17h-.65l-.02.01zm-.58-2.14h-.38v.69h.37c.29 0 .46-.12.46-.35 0-.25-.19-.34-.46-.34h.01zm-3.22-.46h1.74v.47H22.3v.55h1.02v.48H22.3v.62h1.18v.47H21.7v-2.6zm-2.55 2.59v-2.6h.87c.71 0 1.02.23 1.02.65 0 .23-.15.48-.45.55.33.03.6.28.6.61 0 .58-.43.79-1.07.79h-.97zm.58-2.13v.56h.35c.24 0 .38-.12.38-.3s-.15-.26-.41-.26h-.32zm0 1v.66h.45c.28 0 .44-.11.44-.33 0-.22-.2-.32-.44-.32h-.45zm-2.83-1.46h.54v2.12h1.22v.47H16.9v-2.6zm-1.06 2.59-.6-.98h-.37v.98h-.58v-2.6h.96c.7 0 1.02.26 1.02.77 0 .29-.2.53-.48.66l.7 1.17h-.66.01zm-.6-2.13h-.37v.69h.36c.3 0 .47-.12.47-.35 0-.25-.18-.34-.47-.34zm-2 2.13h-.01l-.15-.5h-.9l-.15.5h-.62l.9-2.6h.65l.9 2.6h-.62zm-.9-.96h.6l-.31-.98-.3.98zm-2.02.96-.58-.98h-.37v.98H8.8v-2.6h.95c.7 0 1.03.26 1.03.77 0 .29-.2.53-.5.66l.7 1.17h-.65zm-.58-2.13h-.37v.69h.37c.29 0 .46-.12.46-.35 0-.25-.19-.34-.46-.34zm-2.8-.52c.9 0 1.33.58 1.33 1.35 0 .76-.41 1.36-1.34 1.36-.92 0-1.34-.54-1.34-1.33 0-.77.4-1.38 1.35-1.38zm0 .47c-.55 0-.75.42-.75.88 0 .5.2.9.74.9s.74-.42.74-.9c0-.5-.2-.88-.73-.88zm-2.16-.41h.62l-.9 2.6h-.65l-.9-2.6h.62l.6 1.93.6-1.93zm17.42-5.75a3.42 3.42 0 0 1 3.43-3.34c1.9 0 3.45 1.54 3.45 3.34a3.36 3.36 0 0 1-3.45 3.28 3.36 3.36 0 0 1-3.43-3.28zm5.18 0c0-.9-.79-1.65-1.75-1.65s-1.74.75-1.74 1.65c0 .93.78 1.66 1.74 1.66a1.7 1.7 0 0 0 1.75-1.66zm-11-3.3h-.03 2.55a2.57 2.57 0 0 1 2.57 2.5 2.5 2.5 0 0 1-2.56 2.43h-.84v1.62h-1.69v-6.55zm1.69 3.3h.84c.48 0 .86-.36.86-.8 0-.45-.38-.8-.86-.8h-.84v1.6zm-4.25-3.3h1.7l-2.04 4.93v1.61h-1.7v-1.61l-2.03-4.93h1.7l1.18 2.9 1.2-2.9zm-6.68 2.5v-2.5h1.7v6.54h-1.7V14.3H4.6v2.42H2.9v-6.54h1.7v2.5h2.55z',
        }),
      ),
    );
  },
);
hypovorarlbergSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var hypovorarlberg = {
  category: 'brand',
  colorable: false,
  name: 'hypovorarlberg',
  svg: hypovorarlbergSvg,
};
